const ADMIN_SESSION_KEY = "admin";
const ADMIN_LAST_ACTIVITY_KEY = "adminLastActivity";
export const ADMIN_IDLE_TIMEOUT_MS = 2 * 60 * 60 * 1000;

export const getStoredAdmin = () => {
  try {
    return JSON.parse(localStorage.getItem(ADMIN_SESSION_KEY));
  } catch (error) {
    clearAdminSession();
    return null;
  }
};

export const getLastAdminActivity = () => {
  const lastActivity = Number(localStorage.getItem(ADMIN_LAST_ACTIVITY_KEY));
  return Number.isFinite(lastActivity) && lastActivity > 0 ? lastActivity : null;
};

export const refreshAdminActivity = (time = Date.now()) => {
  if (localStorage.getItem(ADMIN_SESSION_KEY)) {
    localStorage.setItem(ADMIN_LAST_ACTIVITY_KEY, String(time));
  }
};

export const saveAdminSession = (admin) => {
  localStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(admin));
  refreshAdminActivity();
};

export const updateStoredAdmin = (admin) => {
  localStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(admin));
};

export const clearAdminSession = () => {
  localStorage.removeItem(ADMIN_SESSION_KEY);
  localStorage.removeItem(ADMIN_LAST_ACTIVITY_KEY);
};

export const isAdminSessionActive = () => {
  if (!localStorage.getItem(ADMIN_SESSION_KEY)) {
    clearAdminSession();
    return false;
  }

  const lastActivity = getLastAdminActivity();
  if (!lastActivity) {
    refreshAdminActivity();
    return true;
  }

  if (Date.now() - lastActivity >= ADMIN_IDLE_TIMEOUT_MS) {
    clearAdminSession();
    return false;
  }

  return true;
};
